import { multipartFetcher } from '@commenda/utils';

// Not `${BASE_URL}/...`: this endpoint lives under a different prefix from the rest of the domain.
const AGENT_STEP_RESOURCE_URL = 'workflow/agent-step-resource';

export const uploadAgentStepAttachment = async (
  file: File
): Promise<Response> => {
  const body = new FormData();
  // The field name is exactly "file", singular; the controller declares no @Body() at all.
  body.append('file', file);

  return multipartFetcher(`${AGENT_STEP_RESOURCE_URL}/attachment`, {
    method: 'POST',
    body,
  });
};
